export const HARDWARE_FEEDBACK_FORM_URL = "https://forms.gle/UjcyEjYrWcMcPg9m6";

export const HARDWARE_BRACKETBOT_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSehfSHjKqKYtal4GJPxMAC6bL5XzjCHRVy1Xjbzw2LTCqCRkw/viewform?usp=dialog";

export const HARDWARE_HCL_FORM_URL = "https://forms.gle/VPMbPioeKPPJgF486";
